// extracted by mini-css-extract-plugin
module.exports = {"topTabs":"ProfileTabs_topTabs__E6tAV","tab":"ProfileTabs_tab__nFMHb","selectedTab":"ProfileTabs_selectedTab__VYskH"};